import { faGithub, faVk, faTelegram, faFreeCodeCamp } from "@fortawesome/free-brands-svg-icons";

const contactsLinks = [
  { href: "https://github.com/VaysLu", label: "GitHub", icon: faGithub },
  { href: "https://freelance.ru/zvayslu", label: "Freelance", icon: faFreeCodeCamp }, // сюда можно подобрать другую иконку
  { href: "https://vk.com/lucosta", label: "VKontakte", icon: faVk },
  { href: "https://t.me/VaysLu", label: "Telegram", icon: faTelegram },
];

export default contactsLinks;